// ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { isTokenExpired } from "../utils/checkToken";

export default function ProtectedRoute() {
  const token = localStorage.getItem("token");

  if (!token || isTokenExpired(token)) {
    localStorage.removeItem("token");
    return <Navigate to="/" replace />;
  }

  return <Outlet />; // ✅ renders nested protected routes
}
